// extracted by mini-css-extract-plugin
module.exports = {"nav":"Header_nav__xKSep","navBar":"Header_navBar__17qye","fixed":"Header_fixed__2jDQ4","mainNav":"Header_mainNav__i1wnN","logo":"Header_logo__l5cKL"};